import { render } from "./EditOrderItemCard.vue?vue&type=template&id=21ebac24&scoped=true"
import script from "./EditOrderItemCard.vue?vue&type=script&lang=js"
export * from "./EditOrderItemCard.vue?vue&type=script&lang=js"

import "./EditOrderItemCard.vue?vue&type=style&index=0&id=21ebac24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ebac24"]])

export default __exports__